export const detectLoginType = (login: string): 'email' | 'phone' | 'login' => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?\d{10,15}$/;
    
    if (emailRegex.test(login)) {
        return 'email';
    } else if (phoneRegex.test(login)) {
        return 'phone';
    } else {
        return "login"
    }
}